import axios from "axios";
import { config } from "../../config";
import { logger } from "../../lib/logger";
import { ErrorCodes } from "../../lib/errorCodes";
import { TEstimateFee } from "../../types/fee";
import { TActivityTx } from "../../types/activity";
import { Asset } from "../../types/newTypes/Asset";
import { chain } from "lodash";

export const fetchEstimatedFee = async ({
  address,
  symbol,
  chain,
}: {
  address: string;
  symbol: string;
  chain?: string;
}) => {
  try {
    const url =
      `${config.proxyUrl}/api/transaction/estimated-fee?address=${address}&symbol=${symbol.toUpperCase()}` +
      (chain ? `&chain=${chain.toLowerCase()}` : "");
    const headers = {
      "Content-Type": "application/json",
      "api-key": import.meta.env.VITE_PROXY_API_KEY,
      env: "main",
    };
    const response = await axios.get(url, { headers });

    if (response.status !== 200) {
      throw new Error("Somthing went wrong while trying to fetch estimate fee");
    }
    return response.data as TEstimateFee;
  } catch (error) {
    throw new Error(error);
  }
};

export const fetcTransactions = async ({
  address,
  symbol,
  chain,
  contractAddress,
}: {
  address: string;
  symbol: string;
  chain?: string;
  contractAddress?: string;
}) => {
  try {
    const url =
      `${config.proxyUrl}/api/transaction?address=${address}&symbol=${symbol.toUpperCase()}` +
      (chain ? `&chain=${chain.toLowerCase()}` : "") +
      (contractAddress ? `&contractAddress=${contractAddress}` : "");
    const headers = {
      "Content-Type": "application/json",
      "api-key": import.meta.env.VITE_PROXY_API_KEY,
      env: "main",
    };
    const response = await axios.get(url, { headers });

    if (response.status !== 200) {
      throw new Error("Somthing went wrong while trying to fetch transactions");
    }
    return response.data as TActivityTx;
  } catch (error) {
    throw new Error(error);
  }
};

export const fetchAssets = async (assets: Asset[]) => {
  try {
    const url = `${config.proxyUrl}/api/assets`;
    const body = {
      assets: [...assets],
    };

    const headers = {
      "Content-Type": "application/json",
      "api-key": import.meta.env.VITE_PROXY_API_KEY,
      env: "main",
    };

    const response = await axios.post(url, body, { headers });
    return response.data.assets;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      logger.error("api", ErrorCodes.API_002, "fetchAssets Axios error", error, {
        data: error.response?.data,
      });
    } else {
      logger.error("api", ErrorCodes.API_001, "fetchAssets unexpected error", error as Error);
    }
    throw error;
  }
};
